<mat-card [class.card--learner-user]="isLearner"
  [class.card--locked-lesson]="!isLessonUnlocked">

  @if (!isLessonUnlocked) {
    <div
      class="lessonLocked">
      <mat-icon aria-hidden="true"
        svgIcon="lock">
      </mat-icon>
      @if (requirementsToUnlockLesson?.length) {
        <p
          class="lessonLocked__description">
          {{requirementsToUnlockLesson}}
        </p>
      }
    </div>
  }

  @if (isLessonAssigned) {
    <div
      class="card__assignation">
      <mat-icon class="card__assignation-icon"
        svgIcon="assign">
      </mat-icon>
      <span class="card__assignation-label">{{ 'generic.todo' | translate }}</span>
    </div>
  }

  @if (displayLessonBreadcrumb) {
    <app-lesson-card-breadcrumb
      [fields]="LessonBreadcrumbFields"
      [attr.aria-hidden]="!hasLessonBreadcrumb"
      [previousTargetName]="uuid">
    </app-lesson-card-breadcrumb>
  }

  <mat-card-header [ngClass]="headerClasses">

    @if (displayField('titleIcon')) {
      <div class="pastille pastille-icon">
        <mat-icon svgIcon="{{ headerTitleIcon }}"></mat-icon>
      </div>
    }

    @if (displayField('title')) {
      <mat-card-title>
        <h3>{{ headerTitle }}</h3>
        @if (dataCard?.displayLessonState && isManager() && isUserLessons()) {
            <h4>{{ dataCard.lessonState(dataCard.resource) }}</h4>
        }
      </mat-card-title>
    }

    @if (isMenuIsNecessary$() | async) {
      <button [matMenuTriggerFor]="menu"
        ariaLabelTranslate="{{'generic.menu' | translate}}"
        class="mat-icon-button"
        mat-icon-button
        matTooltip="{{'generic.menu' | translate}}">
        <mat-icon svgIcon="submenu"></mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (link of menuLinks; track link) {
          @if (link.displayCondition() | async) {
            <button
                data-e2e="card-menu-link-menu"
              (click)="link.function()"
              mat-menu-item>
              <mat-icon svgIcon="{{link.icon}}"></mat-icon>
              {{ link.label | translate }}
            </button>
          }
        }
      </mat-menu>
    }
  </mat-card-header>

  @if (displayField('image') && (typeOfCard.isLesson || typeOfCard.isSequence)) {
    <img
      alt="" mat-card-image src="{{ contentDetails.image?.uri }}">
  }

  @if (displayField('dynamicLevelTypeImage')
    && (typeOfCard.isLesson || typeOfCard.isSequence)) {
    <img
      [src]="getDynamicLevelTypeImage(dataCard.resource)" alt="" mat-card-image>
  }

  @if (!typeOfCard.isLesson && !typeOfCard.isSequence && !typeOfCard.isVideo) {
    <img
      [ngClass]="getLabelToUse()" mat-card-image
      alt="" class="card-cover" src="{{thumb}}"/>
  }

  <!-- TODO utiliser app-shared-video mais il est dans un autre module et l'importer génère des conflits. Il faut refacto les outils partagés -->
  @if (!displayOnlyMediaIconsType && !typeOfCard.isLesson && !typeOfCard.isSequence && typeOfCard.isVideo) {
    <video
      class="card-cover">
      <source src="{{thumb}}" type="{{dataCard.originalResource?.ressourceEntity.get('reference').filemime}}">
      Your browser does not support HTML5 video.
    </video>
  }

  @if (displayOnlyMediaIconsType && !typeOfCard.isLesson && !typeOfCard.isSequence && typeOfCard.isVideo) {
    <img
      mat-card-image
      alt="" class="card-cover" src="{{'assets/' + brand + '/icons/videoUrl.svg'}}"/>
  }

  <mat-card-content>
    @if (shouldDisplayFields()) {
      <dl class="dl-list content-list" fxFlex fxLayout="column" role="list">
        @for (field of getDisplayedFields(); track field) {
          <div [fxFlexOrder]="getOrder(field)" class="{{field}}-field">
            @if (getFieldTitle(field) && getFieldContent(field)) {
              <dt class="field-title" role="listitem">{{ getFieldTitle(field) | translate }}</dt>
              <dd class="field-content" role="listitem" [innerHTML]="getFieldContent(field)"></dd>
            }
          </div>
        }
      </dl>
    }

    <dl class="dl-list keywords-list" role="list" >
      @if (displayField('keywords') && isLessonOrSequence) {
        <div class="keywords">
          @for (keyword of metadatas?.indexation; track keyword) {
            <dt>
              <a [routerLink]="['/lessons/list/search']"
              [queryParams]="{usage: LessonBreadcrumbFields.usages , title: keyword.label}">{{keyword.label}}</a>
            </dt>
          }
        </div>
      }

      @if (displayField('metadatas') && isLessonOrSequence) {
        <mat-chip-set class="metadatas" tabIndex="-1">
          <mat-chip (click)="dataCard.openMetaDialog($event, metadatas)" class="meta-info">
            <mat-icon svgIcon="info"></mat-icon>
            <span>{{ 'activities.metadata' | translate }}</span>
          </mat-chip>
        </mat-chip-set>
      }
    </dl>

    <div class="card__tags tags">
      @if (displayField('keywords-chip-list') && isLessonOrSequence) {
        <mat-chip-set class="keywords"
          tabIndex="-1">
          @for (keyword of metadatas?.indexation; track keyword) {
            <mat-chip>
              <a [routerLink]="['/lessons/list/search']"
              [queryParams]="{usage: LessonBreadcrumbFields.usages , title: keyword.label}">{{keyword.label}}</a>
            </mat-chip>
          }
        </mat-chip-set>
      }
      @if (displayField('educationalLevel-chip-list') && isLessonOrSequence) {
        <mat-chip-set
          class="educationalLevel" tabIndex="-1">
          @for (educationalLevelItem of metadatas?.educationalLevel; track educationalLevelItem) {
            <mat-chip>
              <a [routerLink]="['/lessons/list/search']"
              [queryParams]="{usage: LessonBreadcrumbFields.usages , educationalLevel: educationalLevelItem.id}">{{educationalLevelItem.label}}</a>
            </mat-chip>
          }
        </mat-chip-set>
      }
    </div>

    @if (showProgressLabel) {
      <div
        class="card__progress-label">
        @if (+getActivitiesCount() > 1) {
          <span class="card__activity-count">{{ getActivitiesCount() }} {{ 'generic.activities' | translate }}</span>
        } @else {
          <span class="card__activity-count">{{ getActivitiesCount() }} {{ 'generic.activity' | translate }}</span>
        }
        @if (lessonProgress > 0) {
          <span
            class="card__lesson-progress">
            ({{ lessonProgress }}%)
          </span>
        }
      </div>
    }

  </mat-card-content>

  <mat-card-actions class="forceAddingTabIndex">
    <!--assign------------------------------------------------------------------- -->
    @if (displayField('assigned') && dataCard.displayAssignedCount && (isLessonOrSequence)) {
      <span (click)="openAssignments()"
        class="info-assignated" fxLayout="row"
        fxLayoutAlign="start center">
        <mat-icon [ngClass]="{'active': assignedCount >= 1 }"
          svgIcon="assignment_ind">
        </mat-icon>
        @if (assignedCount !== 0) {
          <label>
            {{ 'generic.assignated_to' | translate }}
            {{assignedCount}}&nbsp;
            @if (assignedCount > 1) {
              <span>
                {{ 'generic.times' | translate }}
              </span>
            }
            @if (assignedCount === 1) {
              <span>
                {{ 'generic.time' | translate }}
              </span>
            }
          </label>
        }
      </span>
    }
    <!--duplication------------------------------------------------------------------- -->
    @if (displayField('duplication') && dataCard.displayDuplicationCount && (isLessonOrSequence)) {
      <span
        class="info-assignated" fxLayout="row" fxLayoutAlign="start center">
        <mat-icon [ngClass]="{'active': duplicationCount >= 1 }"
          svgIcon="duplicate">
        </mat-icon>
        @if (duplicationCount !== 0) {
          {{ 'generic.duplicated' | translate }}
          {{duplicationCount}}&nbsp;
          @if (duplicationCount > 1) {
            <span>
              {{ 'generic.times' | translate }}
            </span>
          }
          @if (duplicationCount === 1) {
            <span>
              {{ 'generic.time' | translate }}
            </span>
          }
        }
      </span>
    }



    @if (moveActionsButtonInMenu) {
      <!--Affiche les boutons dans un menu-->
      <button class="mat-mdc-card-actions__btn-menu-trigger"
        [matMenuTriggerFor]="menuActions"
        tabindex="0"
        data-e2e="card-menu-actions"
        ariaLabelTranslate="{{'generic.menu' | translate}}"
        matTooltip="{{'generic.menu' | translate}}">
        <span>{{ 'lesson.card_btn-menu' | translate }}</span>
        <mat-icon svgIcon="card-actions__icon-menu-trigger"></mat-icon>
      </button>
      <mat-menu #menuActions="matMenu">
        @for (action of actions; track action) {
          @if (action.displayCondition() | async) {
            <button
              [id]="action.id"
              [title]="(action.title | translate) ?? undefined"
              [ariaLabelTranslate]="(action.title | translate) ?? undefined"
              mat-menu-item
              (click)="action.function($event)"
              [ngClass]="getClasses(action)"
              [fxLayout]="action.fxLayout ? action.fxLayout : undefined"
              [fxLayoutAlign]="action.fxLayoutAlign ? action.fxLayoutAlign : undefined"
              [attr.data-e2e]="action.id"
              [disabled]="action.disabled ? (action.disabled() | async) : false">
              @if (action.icon) {
                <mat-icon
                  svgIcon="{{action.icon}}">
                </mat-icon>
              }
              @if (action.displayLabel) {
                <span>{{ action.displayLabel | translate }}</span>
              }
            </button>
          }
        }
      </mat-menu>
      @if (showFavoriteButton) {
        <button
          class="mat-mdc-card-actions__btn-bookmark"
          data-e2e="card-menu-actions-bookmarks"
          (click)="bookmark()"
          [class]="[isFavorite() ? 'active' : '', 'button-favorite', 'flag'].join(' ')"
          [attr.aria-pressed]="isFavorite()"
          [attr.aria-label]="(isFavorite()?'generic.favoris_selected' :'generic.favoris_unselected') |translate"
          matTooltip="{{'generic.favoris' | translate}}">
          <mat-icon svgIcon="heart"></mat-icon>
        </button>
      }
      <!--for screen reader only-->
      <span class="visually-hidden"
      aria-live="polite"> {{ (isFavorite() ? 'generic.favoris_selected' : 'generic.favoris_unselected') |translate }}</span>
      @if (isEditOrDisableButtonActive()) {
        <button
          class="mat-mdc-card-actions__btn-edit-or-disable"
          (click)="onEditClick($event)"
          data-e2e="card-menu-actions-edit"
          ariaLabelTranslate="{{'card.edit_or_disable' | translate}}"
          [disabled]="(isEditable$ | async) === false">
          <span>{{'card.edit_or_disable' | translate}}</span>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      }
      <button class="mat-mdc-card-actions__btn-play-lesson"
              data-e2e="card-menu-actions-play"
        (click)="this.openLessonPage(dataCard)"
        ariaLabelTranslate="{{'play.lesson_card_button' | translate}}"
        tabindex="0">
        <span>{{ 'lesson.card_open_lesson_page' | translate }}</span>
        <mat-icon svgIcon="play"></mat-icon>
      </button>
    } @else {
      <!--Affiche tous les boutons directement dans <mat-card-actions-->
      @for (action of actions; track action) {
        <!-- TODO mat-mini-fab, mat-button et mat-raised-button ne peuvent pas coexister dans le même bouton, donc l'editeur remonte une erreur, franchement je sais pas si le code ci-dessous est correct, mais ça a l'air de marcher -->
        @if (action.displayCondition() | async) {
          <button
            [id]="action.id"
            [title]="(action.title | translate) ?? undefined"
            [ariaLabelTranslate]="(action.title | translate) ?? undefined"
            [attr.mat-mini-fab]="action.matButtonType === 'mat-mini-fab' && !moveActionsButtonInMenu ?? undefined"
            [attr.mat-button]="action.matButtonType === 'mat-button' && !moveActionsButtonInMenu ?? undefined"
            [attr.mat-raised-button]="action.matButtonType === 'mat-raised-button' && !moveActionsButtonInMenu ?? undefined"
            (click)="action.function($event)"
            [ngClass]="getClasses(action)"
            [fxLayout]="action.fxLayout ? action.fxLayout : undefined"
            [fxLayoutAlign]="action.fxLayoutAlign ? action.fxLayoutAlign : undefined"
            [matMenuTriggerFor]="action.matMenuTriggerFor ? getMenuTriggerFor(action.matMenuTriggerFor) : undefined"
            [attr.data-e2e]="action.id"
            [disabled]="action.disabled ? (action.disabled() | async) : false"
            >
            @if (action.icon) {
              <mat-icon svgIcon="{{action.icon}}"></mat-icon>
            }
            @if (action.displayLabel) {
              <span>{{ action.displayLabel | translate }}</span>
            }
          </button>
        }
      }
    }

    <mat-menu #menuBottom="matMenu">
      @if (isPreviewAvailable() | async) {
        <button (click)="dataCard.play(dataCard.resource)"
                data-e2e="card-menu-actions-play"
          mat-menu-item
          >
          {{ 'generic.run_preview' | translate }}
        </button>
      }
      @if (isLaunchLessonAskModalActive()) {
        <button (click)="openAssignmentWithUserDataFormModal(dataCard.resource)"
                data-e2e="card-menu-actions-open-assignment"
          mat-menu-item>
          {{ 'generic.run_lesson' | translate }}
        </button>
      }
    </mat-menu>
    <mat-menu #menuPdf="matMenu">
      @for (d of pdfList(); track d; let index = $index) {
        <button aria-label="download-pdf"
                data-e2e="card-menu-actions-download"
          mat-raised-button
          (click)="downloadDoc(d.uri)">
          <span>{{'generic.pdf_to_download_' + index |translate}}</span>
        </button>
      }
    </mat-menu>
  </mat-card-actions>
</mat-card>